module.exports = __webpack_public_path__ + "img/head-title2.2cd458eb.png";